import React, { useContext, useEffect, useState } from 'react';
import AuthContext from '../auth/AuthContext';
import { STitleContainer, STitleH3 } from '../common/BCommonComponents';
import { useParams } from 'react-router-dom';
import { DateTime } from 'luxon';
import { payloadLogin } from '../auth/AuthReducer';
import { Card, CardContent } from '@material-ui/core/';
import { Backdrop, Chip, CircularProgress, createStyles, Divider, Grid, IconButton, Paper, Table, TableBody, TableContainer, TableRow } from '@material-ui/core';
import { toast } from 'react-toastify';
import { MedicoDetailDTO, MedicoDTO, PersonalInfoDTO, SceltaMedicoResponseDTO } from '../common/Dtos';
import { FaEye, FaUserNurse } from 'react-icons/all';
import { STableCell, STableHead, STableRow } from '../common/ScrivaniaTable';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import { SceltaMedicoDialog } from './SceltaMedicoDialog';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { SceltaMedicoRecapDialog } from './SceltaMedicoRecapDialog';
import { dateTableFormat } from '../common/DateUtils';

type AdibcParameters = {
	codiceFiscale: string,
	token: string
}

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		backdrop: {
			zIndex: theme.zIndex.drawer + 1,
			color: '#fff',
		},
	}),
);

export function Adiba() {
	const auth = useContext(AuthContext);
	let {codiceFiscale, token} = useParams<AdibcParameters>();
	const [showSpinner, setShowSpinner] = useState<boolean>(false);
	const [first, setFirst] = useState<boolean>(true);
	const [personalInfoDTO, setPersonalInfoDTO] = useState<PersonalInfoDTO>();
	const [medici, setMedici] = useState<MedicoDTO[]>([]);
	const [medicoDetailOpen, setMedicoDetailOpen] = useState<MedicoDetailDTO>();
	const [medicoOpen, setMedicoOpen] = useState<MedicoDTO>();
	const [open, setOpen] = useState<boolean>(false);
	const [sessionExpired, setSessionExpired] = useState<boolean>(false);
	const [openRecap, setOpenRecap] = useState<boolean>(false);
	const [sceltaResponse, setSceltaResponse] = useState<SceltaMedicoResponseDTO>();

	const classes = useStyles();

	useEffect(() => {
		const localLoginPayloadStr = localStorage.getItem('payloadLogin');
		if (localLoginPayloadStr && first) {
			const payloadLogin = JSON.parse(localLoginPayloadStr) as payloadLogin;
			if (DateTime.fromISO(payloadLogin.expiration) > DateTime.now()) {
				auth.dispatch({
					type: 'ADIBA',
					payload: payloadLogin
				});
			} else {
				localStorage.clear();
			}
			setFirst(false);
		}
		if (auth.state.axiosInstance && !sessionExpired) {
			getPersonalInfoAndMedici();
		}
	}, [auth])

	const getPersonalInfoAndMedici = (scroll?: boolean) => {
		setShowSpinner(true);
		auth.state.axiosInstance?.get('/api/adiba/personal-info/' + codiceFiscale + "/" + token)
			.then(res => {
				setPersonalInfoDTO(res.data);
				getMedici(scroll);
			})
			.catch(error => {
				setShowSpinner(false);
				if (406 === error.response.status) {
					if (!sessionExpired) {
						setSessionExpired(true);
						const errorMessage = error.response.data.message.replace('406 ', '').replaceAll('"', '');
						toast.error('🛑 Recupero informazioni assistito: ' + errorMessage);
					}
				} else {
					toast.error('🛑 Errore durante il recupero dei dati del Paziente!');
				}
				console.log(error.response.data);
			})
	}

	const getMedici = (scroll?: boolean) => {
		auth.state.axiosInstance?.get('/api/adiba/medici-list/' + codiceFiscale + "/" + token)
			.then(res => {
				setMedici(res.data);
				setShowSpinner(false);
				if (scroll) {
					window.scrollTo(0, 0);
					setOpenRecap(true);
				}
			})
			.catch(error => {
				setShowSpinner(false);
				if (406 === error.response.status) {
					if (!sessionExpired) {
						setSessionExpired(true);
						const errorMessage = error.response.data.message.replace('406 ', '').replaceAll('"', '');
						toast.error('🛑 Recupero lista medici disponibili: ' + errorMessage);
					}
				} else {
					toast.error('🛑 Errore durante il recupero dei medici!');
				}
				console.log(error);
			})
	}

	const openMedico = (medico: MedicoDTO) => {
		setShowSpinner(true);
		auth.state.axiosInstance?.get('/api/adiba/medico-detail/' + medico.codice_fiscale + "/" + token)
			.then(res => {
				setShowSpinner(false);
				setMedicoDetailOpen(res.data);
				setMedicoOpen(medico);
				setOpen(true);
			})
			.catch(error => {
				setShowSpinner(false);
				if (406 === error.response.status) {
					if (!sessionExpired) {
						setSessionExpired(true);
						const errorMessage = error.response.data.message.replace('406 ', '').replaceAll('"', '');
						toast.error('🛑 Recupero dettagli medico: ' + errorMessage);
					}
				} else {
					toast.error('🛑 Errore durante il recupero dei dati del medico!');
				}
				console.log(error);
			});
	}

	const handleDialogClose = (codiceFiscaleMedico?: string) => {
		if (codiceFiscaleMedico) {
			setShowSpinner(true);
			auth.state.axiosInstance?.get('/api/adiba/scelta-medico/' + codiceFiscale + "/" + codiceFiscaleMedico + "/" + token)
				.then(res => {
					setSceltaResponse(res.data);
					getPersonalInfoAndMedici(true);
				})
				.catch(error => {
					setShowSpinner(false);
					if (406 === error.response.status) {
						if (!sessionExpired) {
							setSessionExpired(true);
							const errorMessage = error.response.data.message.replace('406 ', '').replaceAll('"', '');
							toast.error('🛑 Scelta medico: ' + errorMessage);
						}
					} else {
						toast.error('🛑 Errore durante il recupero dei dati del medico!');
					}
					console.log(error);
				});
		}
		setOpen(false);
	}

	return (
		<div>
			{auth.state.isAuthenticated ?
				<div>
					<STitleContainer>
						<STitleH3>Scelta Medico</STitleH3>
					</STitleContainer>

					{personalInfoDTO &&
						<div>
							<h5>Paziente: {personalInfoDTO.cognome + ' ' + personalInfoDTO.nome}</h5>
							<h5 className="mb-4">Codice fiscale: {personalInfoDTO.codice_fiscale}</h5>
							<Grid container spacing={0} className="w-100 my-4">
								<Grid item xs={12} className="pr-2">
									<Card variant="outlined">
										<CardContent>
											<Grid container spacing={0} className="w-100 my-4 px-5">
												<Grid item xs={6} className="pr-2">
													<p className="font-weight-bold mb-1 d-flex align-items-center">
														<FaUserNurse className="mr-2"/> Medico attuale
													</p>
													<p className="text-muted">
														{personalInfoDTO.cognome_medico + ' ' + personalInfoDTO.nome_medico
															+ ' (cod. reg. ' + personalInfoDTO.codice_regionale_medico + ')'}
													</p>
													<p className="font-weight-bold mb-1">
														Scelto dal
													</p>
													<p className="text-muted">
														{personalInfoDTO.data_inizio_scelta ? dateTableFormat(personalInfoDTO.data_inizio_scelta.substr(0, 10))
															: <span className="font-italic">Informazione non presente</span>}
													</p>
												</Grid>
												<Grid item xs={6} className="pr-2 border-left pl-4">
													<p className="font-weight-bold mb-1">
														Azienda di assistenza
													</p>
													<p className="text-muted">
														{personalInfoDTO.asl_appartenenza ? personalInfoDTO.asl_appartenenza :
															<span className="font-italic">Informazione non presente</span>}
													</p>
													<p className="font-weight-bold mb-1">
														Comune di Residenza
													</p>
													<p className="text-muted">
														{personalInfoDTO.comune_residenza ? personalInfoDTO.comune_residenza :
															<span className="font-italic">Informazione non presente</span>}
													</p>
													<p className="font-weight-bold mb-1">
														Comune di Domicilio Sanitario
													</p>
													<p className="text-muted">
														<span className="font-italic">Informazione non presente</span>
													</p>
												</Grid>
											</Grid>


										</CardContent>
									</Card>
								</Grid>
							</Grid>
							<STitleContainer>
								<STitleH3>Elenco medici</STitleH3>
							</STitleContainer>
							<Grid container spacing={0} className="w-100 my-4">
								<Grid item xs={12}>
									<Paper>
										<TableContainer>
											<Table size="small" aria-label="purchases">
												<TableHead>
													<TableRow>
														<STableHead bgcolor="secondary">MEDICO</STableHead>
														<STableHead bgcolor="secondary">AMB. PRINCIPALE</STableHead>
														<STableHead bgcolor="secondary">CODICE REGIONALE</STableHead>
														<STableHead bgcolor="secondary">TIPOLOGIA</STableHead>
														<STableHead bgcolor="secondary">DISPONIBILE</STableHead>
														<STableHead bgcolor="secondary"/>
													</TableRow>
												</TableHead>
												<TableBody>
													{medici.map((medico) => {
															return (
																<React.Fragment>
																	<STableRow key={medico.codice_fiscale}>
																		<STableCell component="th" scope="row">{medico.cognome + ' ' + medico.nome}</STableCell>
																		<STableCell component="th" scope="row">{medico.ambulatorio_principale ? medico.ambulatorio_principale.ubicazione : ''}</STableCell>
																		<STableCell component="th" scope="row">{medico.codice_regionale}</STableCell>
																		<STableCell component="th" scope="row">
																			<Chip label={medico.tipologia} color="primary" className="text-white"/>
																		</STableCell>
																		<STableCell component="th" scope="row">
																			<Chip label="SI" className="bg-success text-white"/>
																		</STableCell>
																		<TableCell>
																			<IconButton
																				aria-label="expand row"
																				size="small"
																				onClick={() => openMedico(medico)}
																			>
																				<FaEye/>
																			</IconButton>
																		</TableCell>
																	</STableRow>
																</React.Fragment>
															)
														}
													)}
												</TableBody>
											</Table>
										</TableContainer>
									</Paper>
								</Grid>
							</Grid>
							{medicoOpen && medicoDetailOpen &&
								<SceltaMedicoDialog
									open={open}
									onClose={handleDialogClose}
									medico={medicoOpen}
									medicoDetail={medicoDetailOpen}/>
							}
							{sceltaResponse &&
								<SceltaMedicoRecapDialog
									open={openRecap}
									onClose={() => setOpenRecap(false)}
									sceltaResponse={sceltaResponse} />
							}
						</div>
					}
				</div>
				:
				<div>Nessun utente loggato. Impossibile accedere al servizio.</div>
			}
			<Backdrop className={classes.backdrop} open={showSpinner}>
				<CircularProgress color="inherit"/>
			</Backdrop>
		</div>
	)
}
